
// @flow

import React from "react";

const Header = ({background}): React$Element<div> => {
  return(
    <div className="cover__zappbios">
      <div className="cover__background">
        <div className="cover__background-image w-full" style={ { backgroundImage: `url(${background})` } } />
      </div>
    </div>
  )
}

export default Header;
